import { render, staticRenderFns } from "./PrivilegeDisasterEventSend.vue?vue&type=template&id=902c1c9a"
import script from "./PrivilegeDisasterEventSend.vue?vue&type=script&lang=js"
export * from "./PrivilegeDisasterEventSend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports